import styled, { css } from "styled-components";
import { tombac } from "tombac";

export const StyledLimits = {
  Container: styled.div`
    position: relative;
  `,

  Popup: {
    Container: styled.div`
      background-color: ${tombac.color.white};
      box-shadow: ${tombac.space(0, 1, 5, 0.5)} rgba(27, 43, 54, 0.15);
      cursor: default;
      left: 0;
      position: absolute;
      top: ${tombac.unit(70)};
      width: ${tombac.unit(340)};

      &:before {
        content: "";
        border-width: ${tombac.unit(1, 0, 0, 1)};
        background-color: ${tombac.color.white};
        display: block;
        height: ${tombac.space(1)};
        left: ${tombac.space(2)};
        position: absolute;
        width: ${tombac.space(1)};
        top: ${tombac.space(-0.5)};
        transform: rotate(45deg);
      }
    `,

    Header: styled.div`
      border-bottom: ${tombac.unit(1)} solid ${tombac.color("neutral", 400)};
      box-shadow: ${tombac.unit(0, 4, 5, 0)} rgba(93, 93, 93, 0.07);
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding: ${tombac.space(2, 3)};
    `,

    Title: styled.div`
      text-transform: uppercase;
      ${tombac.altText({ fontWeight: "bold" })}
    `,

    Subtitle: styled.div`
      ${tombac.text({ color: tombac.color("neutral", 600), fontSize: 12 })}
    `,

    Item: styled.div`
      border-bottom: ${tombac.unit(1)} solid ${tombac.color("neutral", 400)};
      padding: ${tombac.space(2, 3)};
    `,

    Footer: styled.div<{ isTrial?: boolean }>`
      background-color: ${tombac.color("neutral", 300)};
      display: flex;
      flex-direction: column;
      height: ${tombac.space(7)};
      justify-content: center;
      padding: ${tombac.space(1, 3)};

      ${tombac.text({
        color: tombac.color("neutral", 600),
        fontSize: 12
      })}

      ${({ isTrial = false }) =>
        isTrial
          ? css`
              align-items: center;
              box-sizing: content-box;
              flex-direction: row;
              line-height: 1.5;
              padding: ${tombac.space(2, 3)};
            `
          : undefined}
    `,

    FooterTitle: styled.div`
      font-weight: 500;
    `,

    FooterDescription: styled.div`
      margin-top: ${tombac.space(0.5)};
    `
  }
};
